import jsPDF from "jspdf";

// Relatório de colaboradores registrados: Nome, Telefone, Cidade (+ avaliação média).

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function tstamp() {
  return new Date().toISOString().slice(0, 10);
}

export function downloadTalentCSV(rows) {
  const header = ["Nome", "Telefone", "Cidade", "Avaliação"];
  const esc = (v) => {
    const s = v == null ? "" : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [header.join(",")];
  rows.forEach((r) => {
    lines.push([r.name, r.phone, r.city, r.rating != null ? r.rating : ""].map(esc).join(","));
  });
  // BOM para acentos abrirem certo no Excel
  const blob = new Blob(["\uFEFF" + lines.join("\n")], { type: "text/csv;charset=utf-8;" });
  triggerDownload(blob, `colaboradores-registrados-${tstamp()}.csv`);
}

export function downloadTalentPDF(rows) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const marginX = 40;
  let y = 50;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Colaboradores Registrados", marginX, y);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(120);
  y += 18;
  doc.text(`Gerado em ${new Date().toLocaleDateString("pt-BR")} · ${rows.length} colaborador(es)`, marginX, y);
  doc.setTextColor(0);
  y += 24;

  const cols = [
    { key: "name", label: "Nome", w: 190 },
    { key: "phone", label: "Telefone", w: 130 },
    { key: "city", label: "Cidade", w: 130 },
    { key: "rating", label: "Aval.", w: 65 },
  ];

  const drawHeader = () => {
    doc.setFillColor(30, 41, 59);
    doc.rect(marginX, y - 12, pageW - marginX * 2, 20, "F");
    doc.setTextColor(255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    let x = marginX + 6;
    cols.forEach((c) => {
      doc.text(c.label, x, y + 2);
      x += c.w;
    });
    doc.setTextColor(0);
    doc.setFont("helvetica", "normal");
    y += 20;
  };

  drawHeader();
  doc.setFontSize(10);
  rows.forEach((r, i) => {
    if (y > pageH - 50) {
      doc.addPage();
      y = 50;
      drawHeader();
    }
    if (i % 2 === 0) {
      doc.setFillColor(245, 247, 250);
      doc.rect(marginX, y - 11, pageW - marginX * 2, 18, "F");
    }
    let x = marginX + 6;
    const vals = {
      name: r.name || "—",
      phone: r.phone || "—",
      city: r.city || "—",
      rating: r.rating != null ? String(r.rating) : "—",
    };
    cols.forEach((c) => {
      const txt = doc.splitTextToSize(String(vals[c.key]), c.w - 8)[0] || "";
      doc.text(txt, x, y + 2);
      x += c.w;
    });
    y += 18;
  });

  doc.save(`colaboradores-registrados-${tstamp()}.pdf`);
}
